import { useFavoriteBuses } from "contexts/FavoriteBusesContext/FavoriteBusesContext";
import useMapViewData from "contexts/MapViewDataContext/hooks/useMapViewData";
import React from "react";
import BusItemList from "./BusItemList";
import "./SidebarResultsWrapper.scss";

const SidebarResultsWrapper: React.FC = () => {
    const { scopedBuses } = useMapViewData();
    const { favoritesFilterOn, isFavorite } = useFavoriteBuses();
    const results = favoritesFilterOn
        ? scopedBuses.filter((scopedBus) => isFavorite(scopedBus.bus.niraBusId))
        : scopedBuses;

    return (
        <div className="SidebarResultsWrapper-wrapper">
            <h6 className="bp5-heading SidebarResultsWrapper-heading">
                {results.length} bus
                {results.length !== 1 ? "es" : ""} in map area
            </h6>
            <BusItemList scopedBuses={results} />
        </div>
    );
};

export default SidebarResultsWrapper;
